// extracted by mini-css-extract-plugin
export default {"description":"NCResume_description__SLGdp"};